import { addDays } from 'date-fns'
import { formatDate } from "../../utils";

const generateDataHeatMap = (numberOfDays: number, daysOfStatus: any, date: any) => {
  let i = 0;
  const series = [];

  while (i < numberOfDays) {
    const currentDate = addDays(date.fromDate, i + 1);
    const currentDateString = currentDate.toDateString();

    const matchedDay = daysOfStatus.find((item: any) => {
      const itemDateString = new Date(item.timeStamp).toDateString();
      return itemDateString === currentDateString;
    });

    series.push({
      x: formatDate(currentDate), // para que el gráfico siga mostrando fecha legible
      y: matchedDay ? matchedDay.priority : -1,
      allResolved: matchedDay?.allOutOfRangeMeasuresResolved ?? false,
      // Tri-estado D5 (feature expedientes): derivado del expediente en el backend.
      alertsState: matchedDay?.alertsState ?? 'NO_ALERTS',
    });

    i++;
  }

  return series;
};

export const normalizeHeatMap = (payload: any, meta: any) => {
  const data = payload?.item?.items;
  const date = meta?.params;
  const heatMap = data ? data.map((item: any) => {
    return {
      id: item.id,
      name: item.name,
      data: generateDataHeatMap(7, item.daysOfStatus, date)
    }
  }) : [];
  return heatMap.reverse();
};

export const normalizeDataMeasures = (measuresList: any, payload: any, meta: any) => {
  const data = payload.data?.items;
  const measures = [...measuresList, { patientId: meta.id, name: meta.name, date: meta.params, data }]
  return measures;
};

export const normalizeDataMeasure = (
  payload: any,
  meta: any,
  measureTypeLookup: Record<string, string> = {},
) => {
  const data: any[] = [];
  data.push(payload?.data?.item);
  if (data) {
    const dates = data.map((item: any) => formatDate(item.timestamp));
    const organizeDates = dates.reduce((prev: any, next: any) => {
      return {
        ...prev,
        [next]: data.filter((item: any) => formatDate(item.timestamp) === next),
      };
    }, 0);
    const newData = dates.reduce((prev: any, next: any) => {
      return {
        ...prev,
        [next]: organizeDates[next].map((item: any) => ({
          ...item,
          measureNotes: item.measureNotes ? item.measureNotes.sort((prev: any,  next: any) => {return next.timestamp - prev.timestamp; }) : [],
          items: item.items.map((element: any) => ({
            ...element,
            measureStatus: meta.measureStatus?.find((status: any) => status.id === element.statusId),
            measureType: element.type?.code ? (measureTypeLookup[element.type.code] ?? element.type.code) : '',
          })).sort((prev: any,  next: any) => {return prev.type.genericTypeId - next.type.genericTypeId; }),
        })),
      };
    }, 0);
    return newData;
  }
  return [];
};



